import cls from 'classnames';
import { selectActiveImageByDevice } from 'core/redux/features/products/reducers/products';
import { IProductImage } from 'core/redux/features/products/types';
import { AppState } from 'core/redux/reducers';
import { listen, offset } from 'dom-helpers';
import React, { Component } from 'react';
import LazyLoad, { forceCheck } from 'react-lazyload';
import { connect } from 'react-redux';
import { ImageLoading } from '../../../Components/Loaders';

const mapStateToProps = (state: AppState, ownProps) => {
  const selectImage = selectActiveImageByDevice();
  return {
    activeImage: selectImage(state, ownProps.productId),
    deviceType: state.deviceType,
  };
};

interface IProps {
  productId?: string | undefined;
  // activeImage: IProductImage | undefined,
  isLazy?: boolean;
  getParallaxEl?: () => HTMLElement;
  className?: string;
}

type TProps = IProps & ReturnType<typeof mapStateToProps>;

function PImg(props: {
  parallax: () => HTMLElement;
  src: string;
  activeImage: IProductImage;
}) {
  return (
    <img
      // @ts-ignore
      loading="lazy"
      key={props.src}
      // style={{ opacity: props.parallax ? 0 : 1 }}
      src={props.src}
      alt={props.activeImage.alt}
    />
  );
}

function LoadingEffect() {
  return (
    <div className="">
      <ImageLoading width={768} height={434} />
    </div>
  );
}

/**
 * TODO: add fallback for 404 image?
 */
class ProductImageComp extends Component<TProps, { pOffset: number }> {
  static defaultProps = {
    isLazy: true,
  };

  state = {
    pOffset: 0,
    imgHeight: 0,
  };

  private parallaxScrollRemoveListener: () => void;

  componentDidUpdate(
    prevProps: Readonly<TProps>,
    _prevState: Readonly<{ pOffset: number }>,
    _snapshot?: any,
  ): void {
    this.setupParallax();
    if (prevProps.productId !== this.props.productId) {
      forceCheck();
    }
  }

  componentDidMount(): void {
    this.setupParallax();
    // forceCheck()
  }

  setupParallax() {
    const { getParallaxEl, deviceType } = this.props;
    if (
      deviceType !== 'mobile' ||
      this.parallaxScrollRemoveListener ||
      !getParallaxEl
    ) {
      return;
    }

    const el = getParallaxEl();
    if (!el) {
      return;
    }

    this.parallaxScrollRemoveListener = listen(
      getParallaxEl(),
      'scroll',
      this.refreshParallaxOffset,
    );
  }

  componentWillUnmount(): void {
    if (this.parallaxScrollRemoveListener) {
      this.parallaxScrollRemoveListener();
    }
  }

  private refreshParallaxOffset = () => {
    const offTop = offset(this.props.getParallaxEl()).top;
    this.setState({
      pOffset: offTop,
    });
  };

  render() {
    const {
      props: {
        activeImage,
        className,
        getParallaxEl: isParallax,
        deviceType,
        isLazy,
      },
    } = this;

    const imgurl = activeImage?.url;
    return (
      <div className={className}>
        <div className={cls('image', deviceType === 'mobile' && 'is-16by9')}>
          {deviceType !== 'mobile' && <LoadingEffect />}
          {activeImage ? (
            <>
              {isLazy ? (
                <LazyLoad once={true}>
                  <PImg
                    parallax={isParallax}
                    src={imgurl}
                    activeImage={activeImage}
                  />
                </LazyLoad>
              ) : (
                <PImg
                  parallax={isParallax}
                  src={imgurl}
                  activeImage={activeImage}
                />
              )}
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

const ProductImage = connect(mapStateToProps)(ProductImageComp);

export default ProductImage;
